/* Practiko - reemplaza el boton de PayPal por "Comprar ahora" que lleva directo al pago */
(function(){
  function init(){
    var blocks = document.querySelectorAll('.accelerated-checkout-block');
    blocks.forEach(function(block){
      if (block.dataset.pkDone) return;
      block.dataset.pkDone = '1';
      var form = block.closest('form') || document.querySelector('form.shopify-product-form');
      if (!form) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pk-buynow';
      btn.innerHTML = '<span class="pk-buynow__t">Comprar ahora</span><span class="pk-buynow__s">Tarjeta, SINPE, PayPal o contra entrega</span>';
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        btn.disabled = true;
        btn.querySelector('.pk-buynow__t').textContent = 'Procesando…';
        var fd = new FormData(form);
        var body = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function(r){ if (!r.ok) throw r; window.location.href = '/checkout'; })
          .catch(function(){ btn.disabled = false; btn.querySelector('.pk-buynow__t').textContent = 'Comprar ahora'; alert('No se pudo agregar el producto. Intentá de nuevo.'); });
      });
      block.style.display = 'none';
      block.parentNode.insertBefore(btn, block);
    });
  }
  var css = document.createElement('style');
  css.textContent = '.accelerated-checkout-block{display:none!important}'+
    '.pk-buynow{width:100%;min-height:56px;margin-top:10px;border:0;border-radius:8px;background:#0F172A;color:#fff;cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:10px 16px;font-family:inherit;transition:background .2s}'+
    '.pk-buynow:hover{background:#1D4ED8}.pk-buynow:disabled{opacity:.7;cursor:wait}'+
    '.pk-buynow__t{font-size:1.05rem;font-weight:800;letter-spacing:-.01em}'+
    '.pk-buynow__s{font-size:.75rem;font-weight:500;color:#CBD5E1}';
  document.head.appendChild(css);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
